import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OrderGroupListPage" */
	'pages/supplier/OrderGroup/OrderGroupListPage'));

export default [{ component, exact: true, path: '/order_groups' }];